<template>
  <div>
     <section class=" container section is-main-section">
      <form @submit.prevent="save">
        <div>
            <v-card-component title="Edit Vehicle Bus Route Details" icon="mdi-bus">
               <v-card-actions>
        <router-link :to="{ name: 'vehicleBusRoute' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions>
<v-row>
<v-col>
    <v-row>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Select Vehicle No</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete v-model="vehicleID" key="id" class="my-0 py-1" required  single-line placeholder="---Select---" :items="vehicleDetails" item-text="vehicleRegistrationNumber" item-value="id">
        </v-autocomplete>
      </v-col>
       <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Select Vehicle Driver</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete v-model="driverID" key="id"  class="my-0 py-1" required  single-line placeholder="---Select---" :items="vehicleDriverDetails" item-text="name" item-value="id">
        </v-autocomplete>
      </v-col>
       <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Select Vehicle Cleaner</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete v-model="cleanerID" key="id" class="my-0 py-1" required  single-line placeholder="---Select---" :items="vehicleCleanerDetails" item-text="name" item-value="id">
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
       <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"> State <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="state" required class="my-0 py-1">
        </v-text-field>
      </v-col>
        <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"> City <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="city" required   class="my-0 py-1">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"> Pincode  <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="pincode" counter="6" maxlength="6"
        oninput="javascript: if (this.value.length > this.maxLength ) this.value = this.value.slice(0, this.maxLength);"
        required type="number"  class="my-0 py-1">
        </v-text-field>
      </v-col>
    </v-row>
     <v-row>
       <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"> Route Name  <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="routeName" required class="my-0 py-1">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"> Teacher Incharge 1   <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="teacherIncharge1" required class="my-0 py-1">
        </v-text-field>
      </v-col>
        <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"> Teacher Incharge 1 Mobile no  <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="teacherIncharge1Mobile" required class="my-0 py-1"  maxlength="10"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          type="number"
          counter="10">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
       <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"> Teacher Incharge 2 </span>
        <v-text-field v-model.trim="teacherIncharge2" class="my-0 py-1">
        </v-text-field>
      </v-col>
        <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"> Teacher Incharge 2 Mobile no </span>
        <v-text-field v-model.trim="teacherIncharge2Mobile" class="my-0 py-1"  maxlength="10"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          type="number"
          counter="10">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"> Chief Monitor  <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="chiefMonitor" required  class="my-0 py-1">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Select Vehicle Route Type</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete v-model="routeType" key="id" class="my-0 py-1" required  single-line placeholder="---Select---" :items="routeTypes" item-text="name" item-value="id">
        </v-autocomplete>
      </v-col>
    </v-row>
</v-col>
</v-row>
          <button class="button is-success" :disabled="hasClicked" type="submit" style="margin-top:20px;">Save</button>
  </v-card-component>
        </div>
        <div></div>
      </form>
    </section>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import Utils from '@/utils'
import VCardComponent from '@/components/template/VCardComponent'
export default {
  name: 'editVehicleBusRoute',
  props: ['busRouteID'],
  components: {
    VCardComponent
  },
  data () {
    return {
      total: 0,
      vehicleID: '',
      franchiseeID: '',
      city: '',
      state: '',
      pincode: '',
      routeType: '',
      franchiseeArr: [],
      driverID: '',
      cleanerID: '',
      academicYearID: '',
      academicYears: [],
      vehicleDetails: [],
      routeName: '',
      teacherIncharge1: '',
      teacherIncharge1Mobile: '',
      teacherIncharge2: '',
      teacherIncharge2Mobile: '',
      chiefMonitor: '',
      vehicleDriverDetails: [],
      vehicleCleanerDetails: [],
      vehicleBusRouteData: [],
      title: '',
      hasClicked: false,
      loader: true,
      isWrite: false,
      routeTypes: [
        { id: 0, name: 'Drop', value: 'Drop' },
        { id: 1, name: 'Pick Up', value: 'Pick Up' }
      ],
      allowedFiles: [
        'png', 'jpg', 'jpeg', 'pdf'
      ]
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getYear()
    await this.getFranchiseeList()
    await this.vehicleBusRouteDataDetails()
  },
  methods: {
    vehicleBusRouteDataDetails: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehiclebusroute/${this.busRouteID}`)
        this.vehicleBusRouteData = data
        this.academicYearID = this.vehicleBusRouteData.academicYearID
        this.franchiseeID = this.vehicleBusRouteData.franchiseeID
        this.vehicleID = this.vehicleBusRouteData.vehicleID
        this.driverID = this.vehicleBusRouteData.driverID
        this.cleanerID = this.vehicleBusRouteData.cleanerID
        this.routeName = this.vehicleBusRouteData.routeName
        this.city = this.vehicleBusRouteData.city
        this.pincode = this.vehicleBusRouteData.pincode
        this.state = this.vehicleBusRouteData.state
        this.teacherIncharge1 = this.vehicleBusRouteData.teacherIncharge1
        this.teacherIncharge1Mobile = this.vehicleBusRouteData.teacherIncharge1Mobile
        this.teacherIncharge2 = this.vehicleBusRouteData.teacherIncharge2
        this.teacherIncharge2Mobile = this.vehicleBusRouteData.teacherIncharge2Mobile
        this.chiefMonitor = this.vehicleBusRouteData.chiefMonitor
        if (this.vehicleBusRouteData.isPickUp === true) {
          this.routeType = 1
        } else {
          this.routeType = 0
        }
        this.getVehicleList()
        this.getVehicleDriverList()
        this.getVehicleCleanerList()
        this.loadingComponent.close()
        console.log('this.vehicleBusRouteData.routeType', this.vehicleBusRouteData.isPickUp)
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getVehicleList: async function () {
      try {
        this.vehicleDetails = []
        this.isLoading = true
        let getParam = {}
        getParam.franchiseeID = this.franchiseeID
        getParam.academicYearID = this.academicYearID
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehicledetails`, {
          params: getParam
        })
        if (data.length === 0) {
          this.$buefy.dialog.alert({
            title: 'No Data ',
            message: 'No Vehicle Registered With Selected Franchisee and Academic year',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } else {
          this.vehicleDetails = data
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getVehicleDriverList: async function () {
      try {
        this.vehicleDriverDetails = []
        this.isLoading = true
        let getParam = {}
        getParam.franchiseeID = this.franchiseeID
        getParam.academicYearID = this.academicYearID
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehiclestaff/vehiclestaffdetails/driver`, {
          params: getParam
        })
        if (data.length === 0) {
          this.$buefy.dialog.alert({
            title: 'No Data ',
            message: 'No Driver Registered With Selected Franchisee and Academic year',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } else {
          this.vehicleDriverDetails = data
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getVehicleCleanerList: async function () {
      try {
        this.vehicleCleanerDetails = []
        this.isLoading = true
        let getParam = {}
        getParam.franchiseeID = this.franchiseeID
        getParam.academicYearID = this.academicYearID
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehiclestaff/vehiclestaffdetails/cleaner`, {
          params: getParam
        })
        if (data.length === 0) {
          this.$buefy.dialog.alert({
            title: 'No Data ',
            message: 'No Cleaner Registered With Selected Franchisee and Academic year',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } else {
          this.vehicleCleanerDetails = data
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getYear: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    save: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let formData = new FormData()
        formData.append('franchiseeID', this.franchiseeID)
        formData.append('academicYearID', this.academicYearID)
        formData.append('vehicleID', this.vehicleID)
        formData.append('driverID', this.driverID)
        formData.append('cleanerID', this.cleanerID)
        formData.append('routeName', this.routeName)
        formData.append('teacherInchargeOne', this.teacherIncharge1)
        formData.append('teacherInchargeOneMobile', this.teacherIncharge1Mobile)
        formData.append('teacherInchargeTwo', this.teacherIncharge2)
        formData.append('teacherInchargeTwoMobile', this.teacherIncharge2Mobile)
        formData.append('chiefMonitor', this.chiefMonitor)
        formData.append('city', this.city)
        formData.append('state', this.state)
        formData.append('pincode', this.pincode)
        formData.append('isPickUp', this.routeType)
        // for (var pair of formData.entries()) {
        //   console.log(pair)
        // }
        this.hasClicked = true

        await http.put(`${constants.API_URL}/api/transport/vehicledetails/vehiclebusroute/${this.busRouteID}`, formData)
        this.loader = false
        this.loadingComponent.close()
        this.$router.push({ name: 'vehicleBusRoute' })
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    clearData () {
      this.vehicleDetails = []
      this.franchiseeID = ''
      this.vehicleID = ''
      this.vehicleCleanerDetails = []
      this.cleanerID = ''
      this.vehicleDriverDetails = []
      this.driverID = ''
    }
  }
}
</script>
